@if (isTooBigToDisplay(value)) {
  <div>Item too large to display</div>
} @else {
  <!-- Array rendering -->
  @if (isArray(value)) {
    <div [style.marginLeft.px]="path.length * 20">[</div>
    @for (item of value; let i = $index; track i) {
      <div class="array-row" [style.marginLeft.px]="(path.length + 1) * 20">
        <app-editable-array-or-object
          [value]="item"
          [path]="getPathWith({ index: i })"
          [feature]="feature"
          [isEditable]="isEditable"
        ></app-editable-array-or-object>
      </div>
    }
    <div [style.marginLeft.px]="path.length * 20">]</div>
  }
  <!-- Object rendering -->
  @else if (isObject(value)) {
    <div [style.marginLeft.px]="path.length * 20">&#123;</div>
    @for (prop of value | keyvalue: null; track $index) {
      <div class="object-row" [style.marginLeft.px]="(path.length + 1) * 20">
        <span class="object-subkey"
          ><b>{{ prop.key }}</b></span
        >
        <span class="object-subvalue">
          <app-editable-array-or-object
            [value]="prop.value"
            [path]="getPathWith(prop.key)"
            [feature]="feature"
            [isEditable]="isEditable"
          ></app-editable-array-or-object>
        </span>
      </div>
    }
    <div [style.marginLeft.px]="path.length * 20">&#125;</div>
  }
  <!-- Primitive rendering -->
  <!-- End of recursion, only one that can be edited -->
  @else {
    <span
      [class.value-editable]="isEditable"
      [contentEditable]="isEditable"
      (keydown)="onKeydown($event)"
      (focusout)="onPropertyEdit(feature, $event)"
    >
      {{ value }}
    </span>
  }
}
